var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200.891,
    height: 1080,
    viewBox: "0 0 1200.891 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.757,515.251h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM136.757,515.251v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM150.257,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.757,512.251h10.5v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM160.757,513.751v13.5h4.5v-13.5h-4.5ZM174.257,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.757,512.251h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM198.257,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.257,512.251h3v7.5h4.5v-7.5h3v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM216.257,521.251v6h4.5v-6h-4.5ZM226.757,510.751h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.257,512.251h4.5v-1.5h3v1.5h4.5v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM253.757,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.757,510.751h12v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM270.257,524.251h6v-1.5h6v1.5h6v1.5h-6v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5h4.5v-1.5h1.5v-1.5h-6v-1.5ZM271.757,512.251v7.5h6v-7.5h-6ZM285.257,510.751h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.257,510.751h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM301.757,522.751h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM303.257,516.751v3h6v-3h-6ZM312.257,513.751h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.257,512.251h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h3v4.5h-3v1.5h-6v-1.5h-3v-4.5h3v-1.5h-3v-1.5ZM325.757,524.251h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM327.257,516.751v1.5h1.5v1.5h3v-1.5h1.5v-1.5h-1.5v-1.5h-3v1.5h-1.5ZM328.757,525.751v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM336.257,513.751h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.524,527.251h21v1.5h-21v-1.5ZM432.024,512.251h18v1.5h-15v7.5h15v1.5h-16.5v-1.5h-1.5v-9Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.524,512.251h10.5v7.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-9h7.5v-4.5h-7.5v-1.5ZM468.024,510.751h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.524,527.251h21v1.5h-21v-1.5ZM480.024,512.251h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.524,513.751h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM504.024,522.751h3v6h16.5v1.5h-18v-1.5h-1.5v-6ZM505.524,513.751v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM516.024,510.751h3v4.5h1.5v-4.5h3v10.5h-3v-4.5h-1.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.524,527.251h21v1.5h-21v-1.5ZM528.024,512.251h18v1.5h-15v7.5h15v1.5h-16.5v-1.5h-1.5v-9Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.524,519.751h9v-3h3v3h9v1.5h-21v-1.5ZM552.024,510.751h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM552.024,522.751h3v3h12v-3h3v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM555.024,527.251v1.5h12v-1.5h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.524,519.751h21v1.5h-21v-1.5ZM576.024,512.251h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM576.024,522.751h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM579.024,513.751v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.024,519.751h9v-3h3v3h9v1.5h-21v-1.5ZM607.524,510.751h18v1.5h-15v1.5h15v1.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-6ZM607.524,524.251h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM610.524,525.751v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.024,512.251h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM630.024,518.251h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM633.024,518.251v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM643.524,510.751h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.524,515.251h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM664.524,515.251v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM678.024,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.524,512.251h10.5v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM688.524,513.751v13.5h4.5v-13.5h-4.5ZM702.024,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.524,512.251h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM726.024,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.524,519.751h21v1.5h-21v-1.5ZM735.024,510.751h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM735.024,522.751h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.024,512.251h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM780.024,510.751h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.024,519.751h21v1.5h-9v3h-3v-3h-9v-1.5ZM790.524,512.251h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM790.524,522.751h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM793.524,513.751v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.024,512.251h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM823.524,519.751h3v-9h3v19.5h-3v-9h-3v-1.5ZM831.024,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.524,510.751h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM846.024,522.751h16.5v6h-1.5v1.5h-1.5v-6h-13.5v-1.5ZM847.524,516.751v3h6v-3h-6ZM859.524,510.751h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.524,527.251h21v1.5h-21v-1.5ZM870.024,519.751h4.5v-1.5h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.024,513.751h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM901.524,522.751h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM903.024,513.751v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM915.024,510.751h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.024,527.251h21v1.5h-21v-1.5ZM925.524,515.251h1.5v-1.5h1.5v-1.5h12v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-12v-1.5h-1.5v-1.5h-1.5v-4.5ZM928.524,515.251v4.5h1.5v1.5h9v-1.5h1.5v-4.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.024,527.251h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM949.524,512.251h18v6h-15v3h15v1.5h-16.5v-1.5h-1.5v-4.5h15v-3h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.524,519.751h9v-3h3v3h9v1.5h-21v-1.5ZM981.024,512.251h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM981.024,522.751h7.5v4.5h-4.5v1.5h4.5v1.5h-6v-1.5h-1.5v-3h4.5v-1.5h-4.5v-1.5ZM984.024,513.751v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM990.024,522.751h9v6h-1.5v1.5h-6v-1.5h-1.5v-6ZM993.024,524.251v4.5h3v-4.5h-3Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.524,512.251h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM1015.524,516.751h4.5v-6h3v19.5h-3v-6h-4.5v-1.5h4.5v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.524,527.251h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM1029.024,512.251h3v4.5h12v-4.5h3v9h-1.5v1.5h-15v-1.5h-1.5v-9ZM1032.024,518.251v3h12v-3h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.524,527.251h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM1062.024,519.751h3v-9h3v19.5h-3v-9h-3v-1.5ZM1069.524,510.751h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.524,527.251h4.5v-4.5h3v4.5h6v-4.5h3v4.5h4.5v1.5h-21v-1.5ZM1077.024,515.251h1.5v-1.5h1.5v-1.5h12v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-12v-1.5h-1.5v-1.5h-1.5v-4.5ZM1080.024,515.251v4.5h1.5v1.5h9v-1.5h1.5v-4.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.257,585.684h3v7.5h4.5v-7.5h3v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM144.257,594.684v6h4.5v-6h-4.5ZM154.757,584.184h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.257,585.684h4.5v-1.5h3v1.5h4.5v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM181.757,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.257,585.684h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h3v4.5h-3v1.5h-6v-1.5h-3v-4.5h3v-1.5h-3v-1.5ZM190.757,596.184h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM192.257,590.184v1.5h1.5v1.5h3v-1.5h1.5v-1.5h-1.5v-1.5h-3v1.5h-1.5ZM204.257,584.184h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.757,588.684h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM223.757,588.684v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM237.257,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.757,585.684h10.5v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM247.757,587.184v13.5h4.5v-13.5h-4.5ZM261.257,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.757,585.684h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM285.257,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.257,585.684h10.5v7.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-9h7.5v-4.5h-7.5v-1.5ZM316.757,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.257,593.184h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM325.757,602.184h4.5v-1.5h1.5v-1.5h1.5v-3h4.5v3h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-1.5h-1.5v1.5h-1.5v1.5h-1.5v1.5h-6v-1.5ZM334.757,588.684h3v-4.5h3v10.5h-3v-4.5h-3v-1.5ZM342.257,584.184h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.524,593.184h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM432.024,597.684h3v-1.5h10.5v1.5h3v4.5h-3v1.5h-10.5v-1.5h-3v-4.5ZM435.024,599.184v1.5h1.5v1.5h7.5v-1.5h1.5v-1.5h-1.5v-1.5h-7.5v1.5h-1.5ZM445.524,584.184h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.524,584.184h12v1.5h-9v7.5h9v1.5h-10.5v-1.5h-1.5v-9ZM456.024,596.184h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM469.524,584.184h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.524,600.684h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM478.524,588.684h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM481.524,588.684v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.524,585.684h9v1.5h1.5v4.5h-1.5v1.5h1.5v7.5h-3v-7.5h-4.5v7.5h-3v-15ZM511.524,587.184v4.5h4.5v-4.5h-4.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.524,587.184h1.5v-1.5h9v1.5h-7.5v4.5h6v1.5h-6v6h7.5v1.5h-9v-1.5h-1.5v-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.524,587.184h1.5v-1.5h7.5v1.5h1.5v1.5h-3v-1.5h-4.5v4.5h6v1.5h1.5v6h-1.5v1.5h-7.5v-1.5h-1.5v-1.5h3v1.5h4.5v-6h-6v-1.5h-1.5v-4.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.524,587.184h1.5v-1.5h9v1.5h-7.5v4.5h6v1.5h-6v6h7.5v1.5h-9v-1.5h-1.5v-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.524,585.684h12v1.5h-4.5v13.5h-3v-13.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.024,585.684h3v7.5h4.5v-7.5h3v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM582.024,594.684v6h4.5v-6h-4.5ZM591.024,593.184h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.024,593.184h21v1.5h-21v-1.5ZM604.524,584.184h18v1.5h-15v1.5h15v1.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-6ZM604.524,596.184h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.024,593.184h21v1.5h-21v-1.5ZM628.524,585.684h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM628.524,596.184h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM631.524,587.184v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.524,593.184h21v1.5h-9v3h-3v-3h-9v-1.5ZM660.024,584.184h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM660.024,596.184h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.524,585.684h10.5v7.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-9h7.5v-4.5h-7.5v-1.5ZM694.524,593.184h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.524,600.684h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM708.024,585.684h3v4.5h12v-4.5h3v9h-1.5v1.5h-15v-1.5h-1.5v-9ZM711.024,591.684v3h12v-3h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.524,600.684h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM741.024,593.184h3v-9h3v19.5h-3v-9h-3v-1.5ZM748.524,584.184h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.524,600.684h4.5v-4.5h3v4.5h6v-4.5h3v4.5h4.5v1.5h-21v-1.5ZM756.024,588.684h1.5v-1.5h1.5v-1.5h12v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-12v-1.5h-1.5v-1.5h-1.5v-4.5ZM759.024,588.684v4.5h1.5v1.5h9v-1.5h1.5v-4.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.757,657.615h12v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM246.257,669.615h18v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM247.757,659.115v7.5h6v-7.5h-6ZM249.257,671.115v4.5h12v-4.5h-12ZM261.257,657.615h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.257,669.615h21v1.5h-9v6h-3v-6h-9v-1.5ZM277.757,659.115h3v3h4.5v-3h3v3h4.5v-3h3v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM280.757,663.615v1.5h4.5v-1.5h-4.5ZM288.257,663.615v1.5h4.5v-1.5h-4.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.257,659.115h10.5v7.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-9h7.5v-4.5h-7.5v-1.5ZM316.757,657.615h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.257,659.115h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM340.757,657.615h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.524,666.615h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM432.024,671.115h3v-1.5h10.5v1.5h3v4.5h-3v1.5h-10.5v-1.5h-3v-4.5ZM435.024,672.615v1.5h1.5v1.5h7.5v-1.5h1.5v-1.5h-1.5v-1.5h-7.5v1.5h-1.5ZM445.524,657.615h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.524,657.615h12v1.5h-9v7.5h9v1.5h-10.5v-1.5h-1.5v-9ZM456.024,669.615h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM469.524,657.615h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.524,674.115h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM478.524,662.115h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM481.524,662.115v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.524,659.115h10.5v1.5h1.5v13.5h-3v-13.5h-1.5v13.5h-3v-13.5h-1.5v13.5h-3v-15Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.024,660.615h1.5v-1.5h9v1.5h-7.5v4.5h6v1.5h-6v6h7.5v1.5h-9v-1.5h-1.5v-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.024,659.115h10.5v1.5h1.5v13.5h-3v-13.5h-1.5v13.5h-3v-13.5h-1.5v13.5h-3v-15Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.524,660.615h1.5v-1.5h9v1.5h-7.5v4.5h6v1.5h-6v6h7.5v1.5h-9v-1.5h-1.5v-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.524,659.115h3v7.5h4.5v-7.5h3v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM571.524,668.115v6h4.5v-6h-4.5ZM580.524,666.615h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.524,666.615h21v1.5h-21v-1.5ZM594.024,657.615h18v1.5h-15v1.5h15v1.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-6ZM594.024,669.615h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.524,666.615h21v1.5h-21v-1.5ZM618.024,659.115h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM618.024,669.615h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM621.024,660.615v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.024,669.615h21v1.5h-9v6h-3v-6h-9v-1.5ZM649.524,659.115h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.024,674.115h21v1.5h-21v-1.5ZM673.524,659.115h18v6h-15v3h15v1.5h-16.5v-1.5h-1.5v-4.5h15v-3h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.024,674.115h9v-7.5h3v7.5h9v1.5h-21v-1.5ZM697.524,659.115h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.524,659.115h10.5v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM730.524,660.615v13.5h4.5v-13.5h-4.5ZM742.524,657.615h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.524,669.615h21v1.5h-9v6h-3v-6h-9v-1.5ZM753.024,662.115h1.5v-1.5h1.5v-1.5h12v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-12v-1.5h-1.5v-1.5h-1.5v-3ZM756.024,662.115v3h1.5v1.5h9v-1.5h1.5v-3h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.524,674.115h21v1.5h-21v-1.5ZM777.024,666.615h4.5v-1.5h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.524,666.615h21v1.5h-21v-1.5ZM801.024,657.615h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM801.024,669.615h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.024,666.615h21v1.5h-9v3h-3v-3h-9v-1.5ZM832.524,659.115h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM832.524,669.615h18v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM835.524,660.615v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM835.524,671.115v4.5h12v-4.5h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.024,657.615h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM856.524,669.615h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM871.524,657.615h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.024,662.115h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM882.024,662.115v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM891.024,663.615h4.5v-6h3v19.5h-3v-6h-4.5v-1.5h4.5v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.024,674.115h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM904.524,659.115h3v4.5h12v-4.5h3v9h-1.5v1.5h-15v-1.5h-1.5v-9ZM907.524,665.115v3h12v-3h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.024,674.115h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM937.524,666.615h3v-9h3v19.5h-3v-9h-3v-1.5ZM945.024,657.615h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.024,674.115h4.5v-4.5h3v4.5h6v-4.5h3v4.5h4.5v1.5h-21v-1.5ZM952.524,662.115h1.5v-1.5h1.5v-1.5h12v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-12v-1.5h-1.5v-1.5h-1.5v-4.5ZM955.524,662.115v4.5h1.5v1.5h9v-1.5h1.5v-4.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M453.07,410.203h31.5v2.25h-13.5v4.5h-4.5v-4.5h-13.5v-2.25ZM455.32,396.703h27v2.25h-4.5v6.75h4.5v2.25h-27v-2.25h4.5v-6.75h-4.5v-2.25ZM455.32,416.953h4.5v-2.25h18v2.25h4.5v6.75h-4.5v2.25h-18v-2.25h-4.5v-6.75ZM459.82,419.203v2.25h2.25v2.25h13.5v-2.25h2.25v-2.25h-2.25v-2.25h-13.5v2.25h-2.25ZM464.32,398.953v6.75h9v-6.75h-9Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.07,398.953h6.75v-2.25h4.5v2.25h6.75v2.25h-4.5v2.25h2.25v2.25h2.25v4.5h-2.25v2.25h-2.25v2.25h-9v-2.25h-2.25v-2.25h-2.25v-4.5h2.25v-2.25h2.25v-2.25h-4.5v-2.25ZM489.07,421.453h6.75v-6.75h4.5v6.75h11.25v-24.75h4.5v13.5h6.75v2.25h-6.75v13.5h-4.5v-2.25h-22.5v-2.25ZM493.57,405.703v4.5h2.25v2.25h4.5v-2.25h2.25v-4.5h-2.25v-2.25h-4.5v2.25h-2.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.07,398.953h4.5v22.5h9v-2.25h4.5v2.25h-2.25v2.25h-13.5v-2.25h-2.25v-22.5ZM547.57,396.703h4.5v13.5h6.75v2.25h-6.75v13.5h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.07,403.453h2.25v-2.25h2.25v-2.25h9v2.25h2.25v2.25h2.25v15.75h-2.25v2.25h-2.25v2.25h-9v-2.25h-2.25v-2.25h-2.25v-15.75ZM565.57,403.453v15.75h2.25v2.25h4.5v-2.25h2.25v-15.75h-2.25v-2.25h-4.5v2.25h-2.25ZM585.82,396.703h4.5v29.25h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.07,398.953h15.75v2.25h-11.25v6.75h11.25v2.25h-11.25v11.25h6.75v-2.25h4.5v2.25h-2.25v2.25h-11.25v-2.25h-2.25v-22.5ZM612.82,410.203h4.5v-13.5h4.5v29.25h-4.5v-13.5h-4.5v-2.25ZM624.07,396.703h4.5v29.25h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.32,421.453h2.25v-2.25h2.25v-2.25h2.25v-18h4.5v18h2.25v2.25h2.25v2.25h2.25v2.25h-4.5v-2.25h-2.25v-2.25h-4.5v2.25h-2.25v2.25h-4.5v-2.25ZM666.82,396.703h4.5v13.5h6.75v2.25h-6.75v13.5h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.32,410.203h6.75v-4.5h4.5v4.5h9v-4.5h4.5v4.5h6.75v2.25h-31.5v-2.25ZM682.57,398.953h4.5v-2.25h18v2.25h4.5v6.75h-4.5v2.25h-18v-2.25h-4.5v-6.75ZM682.57,416.953h4.5v-2.25h18v2.25h4.5v6.75h-4.5v2.25h-18v-2.25h-4.5v-6.75ZM687.07,401.203v2.25h2.25v2.25h13.5v-2.25h2.25v-2.25h-2.25v-2.25h-13.5v2.25h-2.25ZM687.07,419.203v2.25h2.25v2.25h13.5v-2.25h2.25v-2.25h-2.25v-2.25h-13.5v2.25h-2.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.32,396.703h4.5v6.75h9v-6.75h4.5v13.5h-2.25v2.25h-13.5v-2.25h-2.25v-13.5ZM718.57,414.703h4.5v4.5h18v-4.5h4.5v9h-2.25v2.25h-22.5v-2.25h-2.25v-9ZM720.82,405.703v4.5h9v-4.5h-9ZM723.07,421.453v2.25h18v-2.25h-18ZM734.32,403.453h6.75v-6.75h4.5v15.75h-4.5v-6.75h-6.75v-2.25Z",
    fill: "#000",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M625.457,342.371h2.626v13.162h-2.626v-13.162Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.814,355.534h2.643v5.268h-2.643v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.814,337.103h2.643v5.268h-2.643v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.188,360.802h2.626v5.251h-2.626v-5.251Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.188,331.834h2.626v5.268h-2.626v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.545,366.053h2.643v2.643h-2.643v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.545,329.209h2.643v2.626h-2.643v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.294,368.696h5.251v2.626h-5.251v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.294,326.583h5.251v2.626h-5.251v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.026,371.322h5.268v2.643h-5.268v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.651,331.834h-2.626v-2.626h-13.162v2.626h-2.626v2.643h-2.643v7.894h5.268v-5.268h2.626v-2.626h5.268v2.626h2.643v5.268h-2.643v2.626h-2.626v2.643h-2.643v5.268h7.911v-2.643h2.626v-2.626h2.626v-2.643h2.643v-10.52h-2.643v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.026,323.94h5.268v2.643h-5.268v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.863,373.965h13.162v2.626h-13.162v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.4,355.534h-7.911v2.626h-2.626v7.894h2.626v2.643h7.911v-2.643h2.626v-7.894h-2.626v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.863,321.315h13.162v2.626h-13.162v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.595,371.322h5.268v2.643h-5.268v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.595,323.94h5.268v2.643h-5.268v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.326,368.696h5.268v2.626h-5.268v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.326,326.583h5.268v2.626h-5.268v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.701,366.053h2.626v2.643h-2.626v-2.643Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.701,329.209h2.626v2.626h-2.626v-2.626Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.075,360.802h2.626v5.251h-2.626v-5.251Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.075,331.834h2.626v5.268h-2.626v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.432,355.534h2.643v5.268h-2.643v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.432,337.103h2.643v5.268h-2.643v-5.268Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.807,342.371h2.626v13.162h-2.626v-13.162Z",
    fill: "#000",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowto);
export default __webpack_public_path__ + "static/media/howto.7061a9e65f30235f6ae98643f0599563.svg";
export { ForwardRef as ReactComponent };